define('view/controller/booking/reschedule/BookingRescheduleDetailsView',['require','marionette','lib/Utils','Config'],function (require) {
	
	var Parent = require('marionette').LayoutView;
	var Utils = require('lib/Utils');
    var Config = require('Config');

	return Parent.extend({
	
	    template: '#booking_reschedule_details_view',
        
        modelEvents: {
            'sync': 'render',
            'change:service': 'safeRender',
            'change:provider': 'safeRender',
            'change:category': 'safeRender',
            'change:location': 'safeRender',
        },
        
        serializeData: function () {
            var products = _.where(this.model.get('product_list'), {type: 'product'});
            var paid_attributes = _.where(this.model.get('product_list'), {type: 'attribute'});
            
            return _.extend(Parent.prototype.serializeData.apply(this), {
                'time_diff': Utils.timeDiff(this.model.toJSON(), this.getOption('clientTimeZone'), 'time_offset'),
                'products': products,
                'paid_attributes': paid_attributes
            });
        },
        
        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        }

	});
	
});
